import { UsMarketClient } from './marketClient';
import { sendUsBrowserRequest, usBrowserSession } from './browserTradingClient';

export function createUsBrowserMarketClient(): UsMarketClient {
  return new UsMarketClient({ session: usBrowserSession, send: sendUsBrowserRequest });
}
